class Pages_active {
  $: any
  constructor($: any) {
    this.$ = $
  }

  activeFunc(url: string[]) {
    const get_class_element = document.getElementsByClassName(
      'pages-' + url[0]
    )[0]

    if (get_class_element) {
      get_class_element.firstElementChild!.classList.add('active')
    }
  }
}
export default Pages_active
